module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-charts"
  }, [(_vm.client == 'just-eat') ? _c('div', {
    staticClass: "client-banner-justeat"
  }) : (_vm.client == 'matalan') ? _c('div', {
    staticClass: "client-banner-matalan"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "ModelButton",
    staticClass: "model-list"
  }, [_c('button', {
    staticClass: "btn toggle-model",
    attrs: {
      "rel": "togglebtnModel"
    },
    on: {
      "click": function($event) {
        return _vm.toggleModel()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('b', [_vm._v("Select a model")])]), _vm._v(" "), _c('div', {
    ref: "Modelmenu",
    staticClass: "dropdown-content hide-model-content"
  }, _vm._l((_vm.joblist), function(currentjob, key) {
    return _c('p', {
      key: key,
      class: _vm.currentjobobj.id == currentjob.id ? 'current-model' : '',
      attrs: {
        "value": currentjob.id
      },
      on: {
        "click": function($event) {
          _vm.selectedJob(currentjob.id);
          _vm.toggleModel()
        }
      }
    }, [_vm._v(_vm._s(currentjob.name) + " | " + _vm._s(currentjob.id))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "model-name"
  }, [_vm._v(_vm._s(_vm.currentjobobj.name) + " | " + _vm._s(_vm.currentjobobj.id))]), _vm._v(" "), _c('div', {
    staticClass: "csv-reports"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goToReports()
      }
    }
  }, [_vm._v("\n        Go to CSV Reports\n        "), _c('i', {
    staticClass: "fa fa-chevron-right chevron-right-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "line-chart"
  }, [_c('div', {
    staticClass: "cardheader line-chart-header"
  }, [_c('strong', [_vm._v(_vm._s(_vm.chart1))]), _vm._v(" "), _c('div', {
    staticClass: "downloadbtn"
  }, [(_vm.downcsvWebTrafficOverviewurl.length) ? _c('a', {
    ref: "downcsvWebTrafficOverviewModel",
    staticClass: "btn btn-lrg btn-primary downcsvtrigger",
    attrs: {
      "href": _vm.downcsvWebTrafficOverviewurl,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download CSV\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.isInChartDataLoad) ? _c('div', {
    staticClass: "dataspinner"
  }, [_c('div', {
    staticClass: "bounce1 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3 makecenter"
  })]) : (_vm.isInChartData) ? _c('div', [(_vm.zoomed) ? _c('button', {
    staticClass: "zoomreset",
    on: {
      "click": function($event) {
        return _vm.zoomTest()
      }
    }
  }, [_vm._v("Reset Zoom")]) : _vm._e(), _vm._v(" "), _c('linechart', {
    ref: "linechart",
    attrs: {
      "chartData": _vm.inchartdata,
      "width": _vm.width,
      "height": _vm.height,
      "options": _vm.options
    }
  })], 1) : _c('div', {
    staticClass: "datanotfound"
  }, [_c('h1', [_vm._v("Sorry, Data not found.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chartrow"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "cardheader"
  }, [_c('strong', [_vm._v(_vm._s(_vm.chart2))]), _vm._v(" "), _c('div', {
    staticClass: "downloadbtn"
  }, [(_vm.downcsvTouchpointHitsurl.length) ? _c('a', {
    ref: "downcsvTouchpointHitsModel",
    staticClass: "btn btn-lrg btn-primary downcsvtrigger",
    attrs: {
      "href": _vm.downcsvTouchpointHitsurl,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download CSV\n          ")]) : _vm._e()])]), _vm._v(" "), (_vm.isTouchpointData) ? _c('div', {
    staticClass: "bar-chart-withbtn"
  }, [_c('div', {
    staticClass: "togglebutton2"
  }, [_c('span', [_c('input', {
    attrs: {
      "id": "yes",
      "value": "yes",
      "type": "radio",
      "name": "touchpointAlluser",
      "selected": _vm.touchpointAllusercheck === true ? true : false
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.touchpointAllusercheck === true ? 'active' : '',
    attrs: {
      "for": "yes"
    },
    on: {
      "click": function($event) {
        return _vm.touchpointAlluser()
      }
    }
  }, [_vm._v("All")])]), _vm._v(" "), _c('span', [_c('input', {
    attrs: {
      "id": "no",
      "type": "radio",
      "value": "no",
      "name": "touchpointAlluser",
      "selected": _vm.touchpointAllusercheck === true ? false : true
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.touchpointAllusercheck === true ? '' : 'active',
    attrs: {
      "for": "no"
    },
    on: {
      "click": function($event) {
        return _vm.touchpointReturninguser()
      }
    }
  }, [_vm._v("Converted")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bar-chart"
  }, [(_vm.isTouchpointDataLoad) ? _c('div', {
    staticClass: "dataspinner"
  }, [_c('div', {
    staticClass: "bounce1 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3 makecenter"
  })]) : (_vm.isTouchpointData) ? _c('div', [_c('barchart', {
    ref: "barchart",
    attrs: {
      "chartData": _vm.touchpointdata,
      "width": _vm.width,
      "height": _vm.height,
      "options": _vm.chartoptions,
      "bind": true
    }
  })], 1) : _c('div', {
    staticClass: "datanotfound"
  }, [_c('h1', [_vm._v("Sorry, Data not found.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "cardheader"
  }, [_c('strong', [_vm._v(_vm._s(_vm.chart3))]), _vm._v(" "), _c('div', {
    staticClass: "downloadbtn"
  }, [(_vm.downcsvLookbackurl.length) ? _c('a', {
    ref: "downcsvLookbackModel",
    staticClass: "btn btn-lrg btn-primary downcsvtrigger",
    attrs: {
      "href": _vm.downcsvLookbackurl,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download CSV\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bar-chart bar-chart-withbtn"
  }, [(_vm.showbutton) ? _c('div', {
    staticClass: "togglebutton"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.existing_channel_range),
      expression: "existing_channel_range"
    }],
    attrs: {
      "id": "yes",
      "value": "yes",
      "type": "radio",
      "name": "existing_channel_groupings",
      "selected": _vm.existing_channel_range === 'yes' ? true : false
    },
    domProps: {
      "checked": _vm._q(_vm.existing_channel_range, "yes")
    },
    on: {
      "change": function($event) {
        _vm.existing_channel_range = "yes"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.existing_channel_range === 'yes' ? 'active' : '',
    attrs: {
      "for": "yes"
    },
    on: {
      "click": function($event) {
        return _vm.fifteenDaysData()
      }
    }
  }, [_vm._v("15 Days")])]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.existing_channel_range),
      expression: "existing_channel_range"
    }],
    attrs: {
      "id": "no",
      "type": "radio",
      "value": "no",
      "name": "existing_channel_groupings",
      "selected": _vm.existing_channel_range === 'yes' ? false : true
    },
    domProps: {
      "checked": _vm._q(_vm.existing_channel_range, "no")
    },
    on: {
      "change": function($event) {
        _vm.existing_channel_range = "no"
      }
    }
  }), _vm._v(" "), _c('label', {
    class: _vm.existing_channel_range === 'yes' ? '' : 'active',
    attrs: {
      "for": "no"
    },
    on: {
      "click": function($event) {
        return _vm.thirtyDaysData()
      }
    }
  }, [_vm._v("30 Days")])])]) : _vm._e(), _vm._v(" "), (_vm.isReturningUsersDataLoad) ? _c('div', {
    staticClass: "dataspinner"
  }, [_c('div', {
    staticClass: "bounce1 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3 makecenter"
  })]) : (_vm.isReturningUsersData) ? _c('div', [_c('barchart', {
    ref: "returninguser",
    attrs: {
      "chartData": _vm.returningusersdata,
      "width": _vm.width,
      "height": _vm.height,
      "options": _vm.returningusersoptions,
      "bind": true
    }
  })], 1) : _c('div', {
    staticClass: "datanotfound"
  }, [_c('h1', [_vm._v("Sorry, Data not found.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "horizontalchart"
  }, [_c('div', {
    staticClass: "cardheader"
  }, [_c('strong', [_vm._v(_vm._s(_vm.chart4))]), _vm._v(" "), _c('div', {
    staticClass: "downloadbtn"
  }, [(_vm.downcsvLastclickVsAttributedurl.length) ? _c('a', {
    ref: "downcsvLastclickVsAttributedModel",
    staticClass: "btn btn-lrg btn-primary downcsvtrigger",
    attrs: {
      "href": _vm.downcsvLastclickVsAttributedurl,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download CSV\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowChannels),
      expression: "isShowChannels"
    }],
    staticClass: "model-list subchannels-list"
  }, [_c('button', {
    staticClass: "btn toggle-model toggle-subchannels",
    attrs: {
      "rel": "togglebtnsubchannels"
    },
    on: {
      "click": function($event) {
        return _vm.toggleChannelsModel()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b', [_vm._v("Select a sub channels")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content subchannels-content hide-subchannels-content"
  }, [_c('p', {
    class: _vm.channelSelected == 'All Channels' ? 'current-model' : '',
    on: {
      "click": function($event) {
        _vm.selectedChannel('All Channels');
        _vm.toggleChannelsModel()
      }
    }
  }, [_vm._v("All Channels")]), _vm._v(" "), _vm._l((_vm.flilteredsubchannellist), function(subchannel, key) {
    return _c('p', {
      key: key,
      class: subchannel == _vm.channelSelected ? 'current-model' : '',
      attrs: {
        "value": subchannel
      },
      on: {
        "click": function($event) {
          _vm.selectedChannel(subchannel);
          _vm.toggleChannelsModel()
        }
      }
    }, [_vm._v(_vm._s(subchannel))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.isAssignedOrderCreditDataLoad) ? _c('div', {
    staticClass: "dataspinner"
  }, [_c('div', {
    staticClass: "bounce1 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3 makecenter"
  })]) : (_vm.isAssignedOrderCreditData) ? _c('div', {
    staticClass: "horizontalbar-charts"
  }, [_c('div', {
    staticClass: "horizontalbar-chart1"
  }, [_c('horizontalchartbar', {
    ref: "horizontalchartbar",
    attrs: {
      "chartData": _vm.assignedordercreditdata,
      "width": _vm.width,
      "height": _vm.height,
      "options": _vm.horizontalchartoptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "horizontalbar-chart2"
  }, [_c('horizontalchartbar', {
    ref: "horizontalchartbar2",
    attrs: {
      "chartData": _vm.assignedordercreditdata2,
      "width": _vm.width,
      "height": _vm.height,
      "options": _vm.horizontalchartoptions2
    }
  })], 1)]) : _c('div', {
    staticClass: "datanotfound"
  }, [_c('h1', [_vm._v("Sorry, Data not found.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-chart"
  }, [_c('div', {
    staticClass: "cardheader"
  }, [_c('strong', [_vm._v(_vm._s(_vm.chart5))]), _vm._v(" "), _c('div', {
    staticClass: "downloadbtn"
  }, [(_vm.downcsvWaterfallurl.length) ? _c('a', {
    ref: "downcsvWaterfallModel",
    staticClass: "btn btn-lrg btn-primary downcsvtrigger",
    attrs: {
      "href": _vm.downcsvWaterfallurl,
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Download CSV\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [(_vm.iswaterfallChartDataLoad) ? _c('div', {
    staticClass: "dataspinner"
  }, [_c('div', {
    staticClass: "bounce1 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2 makecenter"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3 makecenter"
  })]) : (_vm.iswaterfallChartData) ? _c('div', [_c('waterfallchart', {
    ref: "waterfallchart",
    attrs: {
      "chartData": _vm.waterfallJsonData,
      "width": _vm.width,
      "height": _vm.height,
      "options": _vm.waterfallOptions
    }
  })], 1) : _c('div', {
    staticClass: "datanotfound"
  }, [_c('h1', [_vm._v("Sorry, Data not found.")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-th-large",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-th-large",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23bf8700"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardModule.vue
// module id = 997
// module chunks = 1